import { render, staticRenderFns } from "./ExclusionSegmentsConfiguration.vue?vue&type=template&id=34c018f8"
import script from "./ExclusionSegmentsConfiguration.vue?vue&type=script&lang=js"
export * from "./ExclusionSegmentsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports